import React from "react";
import { Navigate } from "react-router-dom";
import { AxiosInterceptor } from "../helpers/AxiosInterceptor";
import { getCurrentRoles, getDefaultRouteForRoles, hasAnyRole } from "../helpers/roles";

// const AppRoute = ({
// 	component: Component,
// 	layout: Layout,
// 	isAuthProtected,
// 	...rest
// }) => (
// 		<Route
// 			{...rest}
// 			render={props => {

// 				if (isAuthProtected && !localStorage.getItem("authUser")) {
// 					return (
// 						<Navigate to={{ pathname: "/login", state: { from: props.location } }} />
// 					);
// 				}

// 				return (
// 					<Layout>
// 						<Component {...props} />
// 					</Layout>
// 				);
// 			}}
// 		/>
// 	);

const AppRoute = (props) => {
	if (!localStorage.getItem("authUser")) {
		return (
			<Navigate to={{ pathname: "/login", state: { from: props.location } }} />
		);
	}
	const roles = getCurrentRoles();
	if (!hasAnyRole(roles, props.roles)) {
		return <Navigate to={getDefaultRouteForRoles(roles)} replace />;
	}
	return (
		<AxiosInterceptor>
			<React.Fragment>
				{props.children}
			</React.Fragment>
		</AxiosInterceptor>);
}

export default AppRoute;

